import { LlmFailureCode } from "../../../../common/models/types";

/**
 * LLM 실패 사유 코드 → 실패 카드 문구 (순수 함수 → 단위 테스트).
 * spec: 2026-08-31-phai-웹-LLM실패-사용자안내 · 화면 설계 3의 슬롯 표.
 *
 * ⚠️ 이 매핑이 문구 정본이다(결정 4). 백엔드가 SSE `message`에 같은 한국어 문구를 실어 보내지만
 *    웹은 그 값을 쓰지 않고 코드로만 렌더한다 — 조회 경로에는 코드만 남기 때문이다.
 *    코드가 없는(null) 과거 실패 건은 이 매핑을 타지 않고 현행 표시를 유지한다(결정 6).
 */
export interface LlmFailureCopy {
  title: string;
  body: string;
  /** 표시할 불릿. 없으면 빈 배열. */
  bullets: string[];
}

/** 사유는 5종이지만 사용자 행동이 갈리는 문구는 3종이다(결정 3). */
const TRANSIENT: LlmFailureCopy = {
  title: "처리 중 문제가 발생했습니다",
  body: "AI 서비스 제공사의 일시적인 오류로 분석하지 못했어요. 잠시 후 다시 시도해 주세요.",
  bullets: [],
};

const UNKNOWN: LlmFailureCopy = {
  title: "처리 중 문제가 발생했습니다",
  body: "분석 중 문제가 발생했어요. 잠시 후 다시 시도해 주세요.",
  bullets: [],
};

const COPY: Record<LlmFailureCode, LlmFailureCopy> = {
  RATE_LIMITED: TRANSIENT,
  TIMEOUT: TRANSIENT,
  PROVIDER_ERROR: TRANSIENT,
  TOKEN_LIMIT: {
    title: "분석할 의약품이 너무 많아요",
    // 본문의 "아래"는 바로 다음에 오는 불릿 2개를 가리킨다.
    body: "한 번에 분석할 수 있는 의약품 수를 넘었어요. 아래를 참고해 의약품 수를 줄인 뒤 다시 시도해 주세요.",
    bullets: ["오래된 처방전은 삭제해주세요.", "중요하지 않은 의약품은 삭제해주세요."],
  },
  UNKNOWN,
};

/**
 * 코드에 해당하는 문구를 돌려준다. 백엔드가 코드를 늘려 웹이 모르는 값이 오면 UNKNOWN 문구로 떨어뜨린다
 * (모르는 코드 때문에 빈 카드가 뜨는 것을 막는다).
 */
export function describeLlmFailure(code: string): LlmFailureCopy {
  return COPY[code as LlmFailureCode] ?? UNKNOWN;
}
